var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1480",
    "data-name": "Group 1480",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.201,
    height: 56.417,
    viewBox: "0 0 78.201 56.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_1636",
    "data-name": "Path 1636",
    transform: "translate(4.222 19.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1636-2",
    "data-name": "Path 1636",
    d: "M81.84,53.484c13.228,0,25.976,7.838,34.841,16.868C109.848,81.983,96.3,89.788,81.84,89.788S53.832,81.983,47,70.352C55.865,61.322,68.612,53.484,81.84,53.484Z",
    transform: "translate(-46.999 -53.484)",
    fill: "#e3f2ff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1637",
    "data-name": "Path 1637",
    transform: "translate(26.858 24.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1637-2",
    "data-name": "Path 1637",
    d: "M97.346,72.363A12.421,12.421,0,1,0,84.926,84.783,12.421,12.421,0,0,0,97.346,72.363Z",
    transform: "translate(-72.505 -59.942)",
    fill: "#a6a6f7"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1638",
    "data-name": "Path 1638",
    transform: "translate(33.869 31.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1638-2",
    "data-name": "Path 1638",
    d: "M85.814,67.841a5.41,5.41,0,1,1-5.41,5.41,5.41,5.41,0,0,1,5.41-5.41Z",
    transform: "translate(-80.404 -67.841)",
    fill: "#7addb6"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469",
    transform: "translate(0 18.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M43.129,74.709a.887.887,0,0,1-.712-1.416c.146-.2,14.828-19.63,36.557-20.757,14.089-.727,27.967,6.229,41.236,20.686a.888.888,0,0,1-1.307,1.2C106.008,60.374,92.6,53.608,79.066,54.309c-20.9,1.084-35.083,19.852-35.224,20.042A.886.886,0,0,1,43.129,74.709Z",
    transform: "translate(-42.242 -52.484)",
    fill: "#4343b5"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1471",
    "data-name": "Group 1471",
    transform: "translate(3.442 35.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M81.742,92.76c-24.558,0-35.514-19.7-35.622-19.9l1.56-.846c.1.19,10.587,18.972,34.061,18.972S115.7,72.2,115.8,72.013l1.56.846C117.255,73.058,106.3,92.76,81.742,92.76Z",
    transform: "translate(-46.12 -72.013)",
    fill: "#4343b5"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    transform: "translate(38.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1472",
    "data-name": "Group 1472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M86.387,45.7a.887.887,0,0,1-.887-.888v-12.1a.888.888,0,0,1,1.775,0v12.1A.887.887,0,0,1,86.387,45.7Z",
    transform: "translate(-85.5 -31.822)",
    fill: "#4343b5"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1475",
    "data-name": "Group 1475",
    transform: "translate(55.793 5.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M105.995,48.743a.888.888,0,0,1-.627-1.515l8.561-8.56a.887.887,0,0,1,1.255,1.255l-8.561,8.56A.885.885,0,0,1,105.995,48.743Z",
    transform: "translate(-105.107 -38.408)",
    fill: "#4343b5"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477",
    transform: "translate(12.315 5.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1476",
    "data-name": "Group 1476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M65.565,48.743a.885.885,0,0,1-.627-.26l-8.56-8.56a.887.887,0,0,1,1.255-1.255l8.56,8.56a.888.888,0,0,1-.627,1.515Z",
    transform: "translate(-56.118 -38.408)",
    fill: "#4343b5"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478",
    transform: "translate(25.178 23.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M84.713,86.25a14.1,14.1,0,1,1,14.1-14.1A14.116,14.116,0,0,1,84.713,86.25Zm0-25.982A11.882,11.882,0,1,0,96.594,72.15,11.9,11.9,0,0,0,84.713,60.268Z",
    transform: "translate(-70.612 -58.049)",
    fill: "#4343b5"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479",
    transform: "translate(32.271 30.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M85.612,80.056a7.008,7.008,0,1,1,7.008-7.008A7.015,7.015,0,0,1,85.612,80.056Zm0-11.8A4.789,4.789,0,1,0,90.4,73.049,4.794,4.794,0,0,0,85.612,68.26Z",
    transform: "translate(-78.604 -66.041)",
    fill: "#4343b5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.8f87100251471902c37c49582b969b3d.svg";
export { ForwardRef as ReactComponent };